import { SIDENAV_ITEMS } from './consts';
import SidenavItem from './components/SidenavItem';
import TextLogo from '@/assets/icons/text_logo_branco.png';
import Logo from '@/assets/icons/logo_branco.png';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useBaseStore } from '@/store';
import { Store } from '@/store/type';
import { getHeaders } from '@/api/utils';

const stateSelector = (state: Store) => ({
  isOpen: state.appConfigSlice.state.isSidenavOpen,
  setIsOpen: state.appConfigSlice.actions.setSidenavOpen,
  profile: state.authSlice.state.profile,
  user: state.authSlice.state.user,
});

const Sidenav = () => {
  const { isOpen, setIsOpen, profile, user } = useBaseStore(stateSelector);
  const label: Record<string, string> = {
    ADMINISTRADOR: 'ADM',
    ADMINISTRADOR_REVENDA: 'ADM REVENDA',
    NOVO: 'NOVO',
    REPRESENTANTE: 'REPRESENTANTE',
  };

  return (
    <>
      {isOpen && (
        <div
          className="absolute top-0 bottom-0 left-0 right-0 z-10 sm:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
      <motion.div
        className={`fixed left-0 flex flex-col h-full z-40 bg-gradient-sidnav border-r-[1px] border-sidenavborder text-white ease-in transition`}
        initial={{
          width: isOpen ? 224 : 56,
        }}
        animate={{
          width: isOpen ? 224 : 56,
        }}
      >
        <Link
          className={`${
            isOpen ? 'px-4' : ''
          } flex items-center w-full gap-2 h-header`}
          to="/"
        >
          {isOpen && <img src={TextLogo} className={`h-5 mx-auto`} />}
          {!isOpen && <img src={Logo} className={`h-8 mx-auto`} />}
        </Link>
        <div
          className={`${
            isOpen ? 'px-1' : 'p-2'
          } flex-1 w-full overflow-y-auto overflow-x-hidden`}
        >
          {SIDENAV_ITEMS.filter((item) =>
            item.accessProfile?.includes(profile || ''),
          ).map((item) => (
            <SidenavItem
              key={item.id}
              id={item.id}
              Icon={item.Icon}
              label={item.label}
              to={item.to}
              subItems={item.subItems}
            />
          ))}
        </div>
        {isOpen && (
          <div className="p-3 flex-shrink-0">
            <div className="rounded-lg p-2 border border-primary-500 bg-primary-500">
              <div className="text-xs text-white/90 text-center">
                <div className="text-white/60 mt-1 text-xs">
                  {`${user} (${label[profile ?? 'NOVO']})`}
                </div>
                <div className="font-medium text-project-teal-lighter">
                  {getHeaders()['x-versao']}
                </div>
              </div>
            </div>
          </div>
        )}
      </motion.div>
    </>
  );
};
export default Sidenav;
